import api from 'api';

export const loadApplications = api(
  'GET /api/main-budget-planning/fields/applications'
);
